import React from 'react';
import { Box, Card, CardContent, Typography, Link } from '@mui/material';

// You can replace the URL below with any space-themed image you like.
const spaceBackground =
  'https://images.unsplash.com/photo-1446776811953-b23d57bd21aa?auto=format&fit=crop&w=1950&q=80';

function WhatsEMCII() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundImage: `url(${spaceBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        p: 2,
      }}
    >
      <Card
        sx={{
          maxWidth: 800,
          backgroundColor: 'rgba(0, 25, 25, 0.3)',
          backdropFilter: 'blur(5px)',
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
        <CardContent>
          <Typography variant="h4" component="h1" gutterBottom>
            What is EMCII?
          </Typography>
          <Typography variant="body1" paragraph>
            EMCII is more than a token—it is the embodiment of our collective wisdom and the catalyst
            for an enlightened community. Designed to empower and connect us, EMCII stands as a beacon
            of human ingenuity, transforming the way we share, evaluate, and celebrate ideas.
          </Typography>
          <Typography variant="body1" paragraph>
            With EMCII, you can submit any idea—from everyday inspirations to groundbreaking clues for
            unraveling the mysteries of black holes—simply by uploading your work as a PDF file. A modest
            fee of <strong>1 $EMCII</strong> accompanies your submission, integrating your contribution
            into a community that values intelligence, creativity, and thoughtful discourse.
          </Typography>
          <Typography variant="body1" paragraph>
            The system is built on a foundation of mutual growth and reward. Every evaluation is a testament
            to our shared commitment to knowledge, with evaluators earning <strong>0.02 $EMCII</strong> per review,
            and creators receiving <strong>0.005 × (evaluation score) $EMCII</strong>. To ensure genuine
            engagement, only those holding at least 50 $EMCII are invited to participate in this noble pursuit.
          </Typography>
          <Typography variant="body1" paragraph>
            As EMCII gains traction, its value will grow not merely as a digital asset, but as a symbol of
            human achievement—a token that reflects the collective intelligence and creativity of our community.
            Join us in forging a future where every contribution, regardless of scale, adds to the rich tapestry of
            human wisdom.
          </Typography>
          {/* リンク追加部分 */}
          <Typography variant="h6" component="div" sx={{ mt: 3 }}>
            Follow Us:
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <Link
              href="https://x.com/EMCII_TOKEN"
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              color="inherit"
            >
              X
            </Link>
            <Link
              href="https://t.me/emcii_token"
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              color="inherit"
            >
              Telegram
            </Link>
            <Link
              href="https://phantom.com/tokens/solana/Gc3eJ7fhAaJR2YsxyNs9nCb4HydBiLryKGxghW613sYK"
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              color="inherit"
            >
              Phantom
            </Link>
            <Link
              href="https://www.okx.com/web3/dex-swap?inputChain=501&inputCurrency=11111111111111111111111111111111&outputChain=501&outputCurrency=Gc3eJ7fhAaJR2YsxyNs9nCb4HydBiLryKGxghW613sYK"
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              color="inherit"
            >
              OKX
            </Link>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}

export default WhatsEMCII;

